<template>
    <v-btn
        class="favorite transition-all"
        fab
        dark
        color="white"
        depressed
        @click.prevent="setFavorite()"
        >
        <div class="position-relative cursor-pointer">
            <img
                :src="selected ? favoriteImg : unfavoriteImg"
                alt=""
                srcset=""
                height="25"
                width="25"
                class="transition-all"
            />
        </div>
    </v-btn>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        selected: { type: Boolean, default: false },
        setFavorite: { type: Function, default: () => {} },
    },
    data() {
        return {
            ribbonImg: require('@/assets/img/favorite/ribbon.svg'),
            favoriteImg: require('@/assets/img/icons/added-list.svg'),
            unfavoriteImg: require('@/assets/img/icons/add-list.svg'),
        }
    },
}
</script>

<style>
.ribbon img {
    margin-right: 3vw;
    z-index: 1;
}
.favorite {
    z-index: 2;
}

@media only screen and (min-width: 1000px) {
    .ribbon img {
        margin-right: 2vw;
    }
    .favorite {
        top: 1vh;
    }
    .favorite:hover img {
        width: 2.5em;
        height: 2.5em;
    }
}
@media only screen and (min-width: 1400px) {
    .favorite:hover img {
        width: 2.5em;
        height: 2.5em;
    }
}
@media only screen and (min-width: 1904px) {
    .ribbon img {
        width: 8vw;
        height: 14vh;
        margin-right: 0vw;
    }
    .favorite img {
        width: 2em;
        height: 2em;
    }
    .favorite:hover img {
        width: 2.5em;
        height: 2.5em;
    }
}
</style>
